import { englishValidationMessages } from './messages';
import { noHtmlPatternValidator } from './rawValidators';
export const makeNoHtmlPatternValidation = (messages)=>(fieldName)=>({
            validate: {
                noHtmlPattern: (value)=>noHtmlPatternValidator(value) || (typeof fieldName === 'string' ? messages.htmlCharacters({
                        field: fieldName
                    }) : false)
            }
        });
/** For react-hook-form library. */ export const noHtmlPatternValidation = makeNoHtmlPatternValidation(englishValidationMessages);
